import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Location } from '@angular-material-extensions/google-maps-autocomplete';
import { AgmMap } from '@agm/core';

import { IMap } from './interfaces/map';
import { IRoute } from './interfaces/route';
import { ITravelMode } from './interfaces/travel-mode';

import { JourneyService } from './services/journey.service';
import { TranslateService } from './services/translate.service';
import { MapsService } from './services/maps.service';

declare var jQuery: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild(AgmMap, {static: true}) agmMap;
  public routes: { [route: string]: IRoute } = this.journeyService.routes;
  public isJourneyDetailsOpened = false;
  public mapReady = new EventEmitter<boolean>(false);
  public travelModes: ITravelMode[] = ['BICYCLING', 'DRIVING', 'TRANSIT', 'WALKING'];
  public mapsData: {
    sameLocation: boolean,
    data: { [mode: string]: IMap },
    origins: { [mode: string]: Location },
    hasMap: { [mode: string]: boolean }
    selectedMap: ITravelMode,
  } = {
    sameLocation: false,
    data: {},
    origins: {},
    hasMap: {},
    selectedMap: null
  };

  @ViewChild('modesList', {static: false}) modesList: ElementRef;
  @ViewChild('detailsModalWALKING', {static: false}) detailsModalWALKING: ElementRef;
  @ViewChild('detailsModalBICLYCLING', {static: false}) detailsModalBICLYCLING: ElementRef;
  @ViewChild('detailsModalDRIVING', {static: false}) detailsModalDRIVING: ElementRef;
  @ViewChild('detailsModalTRANSIT', {static: false}) detailsModalTRANSIT: ElementRef;


  constructor(
    private titleService: Title,
    private changeDetector: ChangeDetectorRef,
    private journeyService: JourneyService,
    private translateService: TranslateService,
    private mapsService: MapsService
  ) { }

  ngOnInit() {
    this.journeyService.detectChanges = this.detectChanges.bind(this);
    this.mapsService.detectChanges = this.detectChanges.bind(this);
    this.titleService.setTitle('TravelBetter | WWF');
  }

  ngAfterViewInit() {
    this.translateService.translate(navigator.language).subscribe();
  }

  detectChanges() {
    this.changeDetector.detach();
    this.changeDetector.detectChanges();
    this.changeDetector.reattach();
  }

  hideAllToggles() {
    this.travelModes.map(mode => {
      jQuery(`#journeyPanel${mode}`).collapse('hide');
      jQuery(`#journeyPanel${mode}`).modal('hide');
    });
  }

  detailsModalToggle() {
    this.hideAllToggles();

    jQuery(`#journeyPanel${this.mapsData.selectedMap}`).modal('toggle');

  }

  setMap(mode?: ITravelMode) {
    this.hideAllToggles();
    this.journeyService.setMap(mode);
    if (mode && this.mapsData && this.mapsData.data[mode] &&
        this.journeyService.map.origin === this.mapsData.data[mode].origin &&
        this.journeyService.map.destination === this.mapsData.data[mode].destination) {
          this.mapsData.selectedMap = mode;
    } else {
      const mapsData = this.mapsService.setMap(mode);
      this.mapsData = mapsData;
    }
    this.detectChanges();
    if (this.mapsData && !this.mapsData.sameLocation) {
      this.scrollToModes();
    }
  }

  setPanel(mode: ITravelMode) {
    return document.querySelector(`#journeyPanelContent${mode}`);
  }

  onMapReady(instance: any, mode: ITravelMode) {
    this.mapsService.onMapReady(instance, mode);
    this.mapReady.emit(true);
  }

  scrollToModes() {
    this.modesList.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}
